import { Component } from '@angular/core';
import { ThemeService } from '../../shared/services/theme.service';
import { RouterLink } from '@angular/router';
import { AnimEmail } from '../../shared/components/anim-email/anim-email';

@Component({
  selector: 'app-success-registration',
  imports: [RouterLink, AnimEmail],
  templateUrl: './success-registration.html',
  styleUrl: './success-registration.css',
})
export class SuccessRegistration {
  constructor(public darkModeService: ThemeService) {}
}
